module.exports = __webpack_public_path__ + "media/images/icon__close--rb-dark-gray@2x-893989eb5399174b8c8c528e6d694d51.png";